import request from '@/utils/request'

const getCompanysById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/companys/${id}`,
    method: 'get'
  })
}

export default {
  getCompanysById
}
